// extracted by mini-css-extract-plugin
export var container = "RegisterForm-module--container--P3Q3g";
export var fbWrapper = "RegisterForm-module--fb-wrapper--xwSPO";
export var formwrapper = "RegisterForm-module--formwrapper--PgKu-";
export var googleWrapper = "RegisterForm-module--google-wrapper--UmXzz";
export var iconWrapper = "RegisterForm-module--icon-wrapper--zLfcs";
export var loginText = "RegisterForm-module--login-text--Z0zEk";
export var registerWrapper = "RegisterForm-module--register-wrapper--JLqZQ";
export var textWrapper = "RegisterForm-module--text-wrapper--qOpsB";